import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const MerchantRoute = ({
  component: ComposedComponent,
  authenticated,
  role,
  ...rest
}) => (
  <Route {...rest}
    exact render={() => authenticated && role.includes('merchant') ?
      <ComposedComponent /> : <Redirect exact strict={true} to="/login" /> }
  />
)

MerchantRoute.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  component: PropTypes.object.isRequired,
  role: PropTypes.array.isRequired,
};

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
  role: auth.user.roles,
});

export default connect(mapStateToProps)(MerchantRoute);
